// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"166":"8b1e35be","225":"63a8a0f0","904":"d9090afc"}[chunkId] + ".chunk.css";
};